export default __webpack_public_path__ + "f5a83abd49fef86216fb18d6bf3bb7f0.png";